define('views/app/supervisor/member',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'toastr', 'services/i18n',
    //services
    'services/session',
    'services/user',
    'services/events/user-events',
    // Views
    'src/views/responsive-view',
    'views/parts/menu/menu',
    'views/modules/profile/profile',
    'views/modules/calendar/calendar/calendar',
    'views/modules/graph/graph',
    'views/modules/goal/goal',
    'views/modules/conversation/conversation',
    'views/modules/note/note',
    // Templates
    'text!templates/app/supervisor/member.html'
], function(
    // Libs
    _, Backbone, Mustache, U, Toastr, i18n,
    //Service
    Session,
    User,
    UserEvents,
    // Views
    VResponsive,
    VMenu,
    VProfile,
    VCalendar,
    VGraph,
    VGoal,
    VConversation,
    VNote,
    // Templates
    TSupervisorPageClient
) {
    var pageViewMap = {
        calendar: VCalendar,
        graph: VGraph,
        goal: VGoal,
        message: VConversation,
        note: VNote,
    };

    var VAppSupervisorMember = VResponsive.extend({

        template: TSupervisorPageClient,

        regions: {
            profile: '#profile',
            nav: '#navigation',
            content: '#content',
        },

        initialize: function(opt) {

            opt = opt || {};

            this.group = opt.group;
            this.role = opt.role;
            this.url = opt.url;

            this.setUrl("root", "#/" + this.url.current);

            // main page navigation
            this.nav = {
                calendar: new Backbone.Model({ fragment: "#/" + this.url.calendar, content: 'calendar:Calendar', icon: 'sl-icon-calendar' }),
                graph: new Backbone.Model({ fragment: "#/" + this.url.graph, content: 'graph:Graphs', icon: 'sl-icon-pie-chart' }),
                goal: new Backbone.Model({ fragment: "#/" + this.url.goal, content: 'goal:Goals', icon: 'sl-icon-flag' }),
                message: new Backbone.Model({ fragment: "#/" + this.url.message, content: 'Messages', icon: 'sl-icon-envelope', /* badge: '5' */ }),
                note: new Backbone.Model({ fragment: "#/" + this.url.note, content: 'note:Coach Notes', icon: 'sl-icon-note' }),
            };

            // Inistialize Views
            this.view = {
                profile: new VProfile({
                    model: this.model
                }),
                navigation: new VMenu({
                    context: this,
                    radio: true,
                    collection: new Backbone.Collection(_.values(this.nav)),
                    // namespace: ["member_home", "team"]
                })
            };

            this.listenTo(this.model, 'sync', this.onUserUpdate);
            this.listenTo(UserEvents, 'switchMode', this.onSwitchMode);

        },

        render: function() {
            this._updateNav();
            // Render Template HTML with Mustache
            var html = Mustache.render(this.template);
            this.$el.empty().append(html);

            this.generateZones();

            this.assign(this.view.profile, this.zone.$profile)
                .assign(this.view.navigation, this.zone.$nav);

            if (this.view.content) {
                this.assign(this.view.content, this.zone.$content);
            } else {
                // this.renderCalendar();
                this.showPage('calendar');
            }

            this.verifyUserGroupMembership();

            this.setRollbarLoggerProfile();
        },

        setRollbarLoggerProfile: function() {
            // Set the person data to be sent with all errors for this notifier.
            window.Rollbar.configure({
              payload: {
                person: {
                  id: User.get('_id'),
                  username: User.get('displayName'),
                  email: User.get('email')
                }
              }
            });

        },

        verifyUserGroupMembership: function() {
            if (U.getCookieByName('TCNeddExpirationToastr') === "true") {
                var message = i18n.t("messages:message-expiration-in-one-group"),
                    title = i18n.t("Expiration");

                Toastr.error(
                    message,
                    title, { // These options should be set globally.
                        positionClass: "toast-top-center", // Default = toast-top-right
                        newestOnTop: true, // Default = true
                        showMethod: "slideDown",    // Default = fadeIn
                        tapToDismiss: true,  // Default = false
                        closeButton: true
                    }
                );
                document.cookie = "TCNeddExpirationToastr=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            }
        },
        /////////////
        // Content //
        /////////////
        showPage: function(key, options) {
            options = options || {};
            if (!this.view[key]) {
                this.view[key] = new pageViewMap[key]({
                    model: this.model, // pass the user profile model
                    group: this.group, // current group
                    url: this.url,
                    role: this.role,
                });
            }

            var view = this.view[key],
                navItem = this.nav[key];

            view.setUrl("root", navItem.get('route'));
            navItem.trigger('toggle:active', true);

            if (this.view.content !== view) {
                if (this.view.content) {
                    this.view.content.disable();
                }
                this.view.content = view;
                this.assign(this.view.content, this.zone.$content);
            }
            return this;
        },

        getView: function(key, options) {
            var viewObj = this.view,
                view = viewObj[key];
            if (!view) {
                view = viewObj[key] = new pageViewMap[key](options);
            }
            return view;
        },

        // Updates the navigation route with the new profile id.
        _updateNav: function() {
            var data = {
                groupId: this.group.id,
                userId: this.model.id
            };
            _.each(this.nav, function(nav) {
                nav.set({ route: Mustache.render(nav.get('fragment'), data) });
            }, this);
        },

        ////////////
        // events //
        ////////////
        onUserUpdate: function() {
            this._updateNav();
        },

        onResize: function(e, width) {
            if (this.view && this.view.content && this.view.content.onResize) {
                this.view.content.onResize(e, width);
            }
        },

        onSwitchMode: function() {
            this.view.content.disable();
        }

    });

    return VAppSupervisorMember;

});

